const MontserratSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111935)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M19.9463 19.9998H19.9998C19.9998 19.9818 19.9998 19.9643 19.9998 19.9463C19.982 19.9642 19.9642 19.982 19.9463 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.95242 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3106 20H19.9466C19.9644 19.9822 19.9822 19.9644 20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1186 2.6084C6.99053 4.38957 4.38998 6.99004 2.60889 10.1181V19.9997H7.82631V7.82598V7.82582H20.0002C20.0002 6.18027 20.0002 4.61262 20.0002 2.6084H10.1186Z"
        fill="#D80027"
      />
      <path
        d="M19.9998 17.5403L12.8939 10.4346H10.4346V10.4347L19.9996 19.9997H19.9998C19.9998 19.9997 19.9998 18.3039 19.9998 17.5403Z"
        fill="#D80027"
      />
      <path
        d="M22.6089 10.4346V19.9997C22.6089 24.6591 28.6958 26.0868 28.6958 26.0868C28.6958 26.0868 34.7828 24.6591 34.7828 19.9997V10.4346H22.6089Z"
        fill="#338AF3"
      />
      <path
        d="M22.6089 20C22.6089 24.6594 28.6958 26.087 28.6958 26.087C28.6958 26.087 34.7828 24.6594 34.7828 20H22.6089Z"
        fill="#A2001D"
      />
      <path
        d="M31.3043 14.7822H29.5651V13.043H27.826V14.7822H26.0869V16.5213H27.826V21.7386H29.5651V16.5213H31.3043V14.7822Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111935">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MontserratSvg;
